import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchMetaCatalogAttributes } from '../services/meta-catalog-attributes.service';

/**
 * The Meta attribute catalogue, cached for the session: it is baked into the agent
 * image, so it cannot change between requests. `enabled` defers the fetch until the
 * consumer (the run panel) actually opens.
 */
export function useMetaCatalogAttributes(enabled: boolean, includePassThrough = false) {
  return useQuery({
    queryKey: queryKeys.agents.metaCatalogAttributes(includePassThrough),
    queryFn: () => fetchMetaCatalogAttributes(includePassThrough),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
